import CreateDialog from '../Create.vue';
import http from '@/components/services/http-common';
import moment from 'moment/moment';
import exportToExcel from '@/components/services/jsonToExcel';

export default {
    components: {
        "create-dialog": CreateDialog,
    },
    watch: {
        dialog(val) {
            if (!this.dialog)
                this.item = null;
        },
        month(val) {
            this.fetchData();
        }
    },
    computed: {
        types() {
            // Lấy danh sách loại hỗ trợ duy nhất (loại trừ giá trị rỗng/null/undefined)
            let typeItems = this.items.map(x => x.typeSupportName);
            let types = [...new Set(typeItems.filter(Boolean))];
            return types;
        },
        senderDepts() {
            // Danh sách phòng ban gởi duy nhất
            let deptItems = this.items.map(x => x.departmentSenderName);
            return [...new Set(deptItems.filter(Boolean))];
        },
        receiveDepts() {
            // Danh sách phòng ban nhận duy nhất
            let deptItems = this.items.map(x => x.departmentReceiveName);
            return [...new Set(deptItems.filter(Boolean))];
        },
        // Lọc dữ liệu client-side dựa trên các trường filter ở Index
        filteredItems() {
            return this.items.filter(item => {
                if (this.filterCode && !item.code?.toUpperCase().includes(this.filterCode.toUpperCase())) return false;
                if (this.filterTypeName && !item.typeSupportName?.toUpperCase().includes(this.filterTypeName.toUpperCase())) return false;
                if (this.filterSenderCode && !item.senderCode?.toUpperCase().includes(this.filterSenderCode.toUpperCase())) return false;
                if (this.filterSender && !item.senderName?.toUpperCase().includes(this.filterSender.toUpperCase())) return false;
                if (this.filterReceiver && !item.receiveName?.toUpperCase().includes(this.filterReceiver.toUpperCase())) return false;
                if (this.filterCompleter && !item.completeName?.toUpperCase().includes(this.filterCompleter.toUpperCase())) return false;
                if (this.filterSenderDept && !item.departmentSenderName?.toUpperCase().includes(this.filterSenderDept.toUpperCase())) return false;
                if (this.filterReceiveDept && !item.departmentReceiveName?.toUpperCase().includes(this.filterReceiveDept.toUpperCase())) return false;
                if (this.filterStatus && !item.supportStatusName?.includes(this.filterStatus)) return false;
                return true;
            });
        }
    },
    data() {
        return {
            month: moment().startOf("months").format("YYYY-MM"),
            dialog: false,
            item: null,
            items: [],
            search: "",
            headers: [
                { text: "", value: "actions", width: "7rem" },
                { text: "Mã", value: "code", width: "10rem" },
                { text: "Loại", value: "typeSupportName", width: "9rem" },
                { text: "Lý do", value: "titleSender", width: "9rem" },
                { text: "Mã NS người gởi", value: "senderCode", width: "9rem" },
                { text: "Người gởi", value: "senderName", width: "10rem" },
                { text: "Người nhận", value: "receiveName", width: "10rem" },
                { text: "Người hoàn thành", value: "completeName", width: "10rem" },
                { text: "Phòng ban gởi", value: "departmentSenderName", width: "10rem" },
                { text: "Phòng ban nhận", value: "departmentReceiveName", width: "10rem" },
                { text: "Ngày gởi", value: "sendDateStr", width: "7rem" },
                { text: "Đánh giá", value: "evaluate", width: "5rem" },
                { text: "Trạng thái", value: "supportStatusName" },
            ],

            statusColor: {
                "Tạo mới": "green",
                "Tiếp nhận": "orange",
                "Từ chối": "red",
                "Hoàn thành": "cyan",
            },
            // *** Filter ***
            filterTypeName: "",
            filterStatus: "",
            filterCode: "",
            filterSenderCode: "",
            filterSender: "",
            filterReceiver: "",
            filterCompleter: "",
            filterSenderDept: "",
            filterReceiveDept: "",

            dialogDelete: false,
            targetItem: null,
        }
    },
    methods: {
        blockClick(event) {
            event.stopPropagation()
        },
        
        // Tải dữ liệu phiếu hỗ trợ và sắp xếp phiếu mới nhất lên đầu
        fetchData() {
            return http.get("supports", {
                params: {
                    month: this.month
                }
            }).then(res => {
                let data = res.data || [];
                // Sắp xếp phiếu mới nhất lên đầu
                data.sort((a, b) => {
                    // Ưu tiên so sánh qua sendDate (nếu có)
                    if (a.sendDate && b.sendDate) {
                        return new Date(b.sendDate) - new Date(a.sendDate);
                    }
                    // Nếu không có sendDate, parse sendDateStr bằng moment
                    if (a.sendDateStr && b.sendDateStr) {
                        const dateA = moment(a.sendDateStr, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD']);
                        const dateB = moment(b.sendDateStr, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD']);
                        if (dateA.isValid() && dateB.isValid()) {
                            return dateB.valueOf() - dateA.valueOf();
                        }
                    }
                    // Fallback: Sắp xếp theo mã code giảm dần
                    if (a.code && b.code) {
                        return b.code.localeCompare(a.code);
                    }
                    return 0;
                });
                this.items = data;
            })
        },
        setSelect(e) {
            this.item = { code: e };
        },
        
        edit(item) {
            this.item = item;
            this.dialog = true;
        },
        deleteItem(item) {
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            let url = `supports/${this.targetItem.code}`;
            return http.delete(url).then(res => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                switch (err.response.status) {
                    case 403: {
                        this.unauthorizeAlert();
                        this.dialogDelete = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },
        
        // Xuất file excel từ dữ liệu đã lọc trên Index (client-side)
        exportExcel() {
            if (!this.filteredItems || this.filteredItems.length === 0) {
                alert("Không có dữ liệu để xuất excel!");
                return;
            }

            const formattedData = this.filteredItems.map(item => ({
                "Mã phiếu": item.code,
                "Loại hỗ trợ": item.typeSupportName,
                "Lý do": item.titleSender,
                "Mô tả": item.descriptionSender,
                "Mã NS người gởi": item.senderCode,
                "Người gởi": item.senderName,
                "Người nhận": item.receiveName,
                "Người hoàn thành": item.completeName,
                "Phòng ban gởi": item.departmentSenderName,
                "Phòng ban nhận": item.departmentReceiveName,
                "Ngày gởi": item.sendDateStr,
                "Đánh giá": item.evaluate,
                "Trạng thái": item.supportStatusName
            }));

            const fileName = `DanhSachPhieuHoTro_${moment(this.month).format("MM-YYYY")}_${moment().format('YYYYMMDD_HHmmss')}`;
            exportToExcel(formattedData, fileName);
        },
    },
    mounted() {
        this.fetchData();
    }
}